export default __webpack_public_path__ + "8ff08062e9f036f081a50439ab2091d1.webp";